import { render, staticRenderFns } from "./CatalogMiniature.vue?vue&type=template&id=7581dddd&scoped=true"
import script from "./CatalogMiniature.vue?vue&type=script&lang=ts"
export * from "./CatalogMiniature.vue?vue&type=script&lang=ts"
import style0 from "./CatalogMiniature.vue?vue&type=style&index=0&id=7581dddd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7581dddd",
  null
  
)

export default component.exports